import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=161cceba&lang=html&"
import script from "./delete.vue?vue&type=script&lang=js&"
export * from "./delete.vue?vue&type=script&lang=js&"
import style0 from "./delete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports